import { useEffect } from 'react';

const HOTJAR_ID = 6588339;

/**
 * Hook to load Hotjar tracking script
 * Only loads once when the component mounts
 */
export const useHotjar = () => {
	useEffect(() => {
		// Check if Hotjar is already loaded by checking for the function or settings
		// eslint-disable-next-line no-prototype-builtins
		if (window.hj || window.hasOwnProperty('_hjSettings')) {
			return;
		}

		// Load Hotjar tracking script
		(function(h,o,t,j,a,r){
			h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
			h._hjSettings={hjid:HOTJAR_ID,hjsv:6};
			a=o.getElementsByTagName('head')[0];
			r=o.createElement('script');r.async=1;
			r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
			a.appendChild(r);
		})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
	}, []);
};
